var _rect, _text, _text2, _rect2, _text3, _text4, _text5, _text6, _text7, _text8, _line, _polygon, _text9, _rect3, _text10, _text11, _text12, _text13, _text14, _text15, _line2, _polygon2, _text16, _rect4, _text17, _text18, _text19, _text20, _text21, _text22, _text23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBehavioralIntelligenceStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 500",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boxGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#111111",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#DCCA87",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#DCCA87",
      stopOpacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "layer1Grad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2a2a2a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "layer2Grad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1f2a1f",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#151f15",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "layer3Grad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2a251a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a1810",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    rx: 8,
    fill: "#0C0C0C",
    stroke: "#DCCA87",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 36,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 11,
    fill: "#DCCA87",
    letterSpacing: 2,
    opacity: 0.7
  }, "THE INTELLIGENCE STACK")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 56,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#777777"
  }, "From Traces to Behavioral Intelligence \u2014 Each Layer Elevates What the Previous Enables")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 380,
    width: 640,
    height: 90,
    rx: 6,
    fill: "url(#layer1Grad)",
    stroke: "#666666",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 408,
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#888888",
    letterSpacing: 1
  }, "LAYER 1")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 430,
    fontFamily: "sans-serif",
    fontSize: 15,
    fill: "#CCCCCC",
    fontWeight: 500
  }, "Distributed Traces")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 452,
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#888888"
  }, "Spans, timing, call sequences, error codes")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 420,
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#666666"
  }, "Answers: WHAT happened")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 440,
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#666666"
  }, "Limitation: Flat, structural, per-call")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 460,
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#666666"
  }, "Tools: OTel, Jaeger, LangSmith")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 378,
    x2: 400,
    y2: 328,
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1,
    strokeDasharray: "4,2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "396,330 400,322 404,330",
    fill: "#DCCA87",
    fillOpacity: 0.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 358,
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#DCCA87",
    opacity: 0.7
  }, "elevates to")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 240,
    width: 640,
    height: 90,
    rx: 6,
    fill: "url(#layer2Grad)",
    stroke: "#5a8a5a",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 268,
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#7ab87a",
    letterSpacing: 1
  }, "LAYER 2")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 290,
    fontFamily: "sans-serif",
    fontSize: 15,
    fill: "#CCCCCC",
    fontWeight: 500
  }, "Session Graphs")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 312,
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#888888"
  }, "Causal DAGs, execution lineage, context evolution")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 278,
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#5a8a5a"
  }, "Answers: HOW it happened")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 298,
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#5a8a5a"
  }, "Enables: Topology, sequence, correlation")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 318,
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#5a8a5a"
  }, "Product: LexiLensAI Session Engine")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 238,
    x2: 400,
    y2: 188,
    stroke: "#DCCA87",
    strokeOpacity: 0.6,
    strokeWidth: 1,
    strokeDasharray: "4,2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "396,190 400,182 404,190",
    fill: "#DCCA87",
    fillOpacity: 0.7
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 218,
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#DCCA87",
    opacity: 0.9
  }, "elevates to")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 90,
    width: 640,
    height: 100,
    rx: 6,
    fill: "url(#layer3Grad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.6,
    strokeWidth: 1.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 118,
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#DCCA87",
    letterSpacing: 1
  }, "LAYER 3")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 142,
    fontFamily: "sans-serif",
    fontSize: 15,
    fill: "#FFFFFF",
    fontWeight: 600
  }, "Behavioral Intelligence")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 164,
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#AAAAAA"
  }, "Learned patterns, proactive detection, causal reasoning")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 180,
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#AAAAAA"
  }, "Cross-session learning, absence detection, intervention")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 128,
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Answers: WHY it happened")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 148,
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Enables: Prediction, prevention, governance")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 168,
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Product: LexiLensAI Behavioral Engine")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehavioralIntelligenceStack);
export default __webpack_public_path__ + "static/media/behavioral-intelligence-stack.8a73a2d7a8917631f0978ea252061390.svg";
export { ForwardRef as ReactComponent };